module.exports = __webpack_public_path__ + "img/lock-expired.a03c9fe1.svg";